// src/components/MetaPixel.js - Fixed version
import { useEffect } from 'react';

const MetaPixel = ({ funnelId = null }) => {
  useEffect(() => {
    const win = /** @type {any} */ (window);

    // Check for production environment
    // Note: NODE_ENV is the standard env variable React uses
    const isProduction = process.env.REACT_APP_ENV === 'production';

    // Only load the real pixel in production
    if (isProduction && funnelId !== '14' && funnelId !== '10') {
      // Initialize Meta Pixel
      (function (f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
      })(win, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');

      win.fbq('init', '967265705486175');
      win.fbq('track', 'PageView');

      console.log('Meta Pixel initialized in production mode');
    } else {
      // Set up a more robust mock for development
      win.fbq = function () {
        console.log('Meta Pixel (development):', ...arguments);
      };

      // Set up required properties to prevent errors if code tries to check these
      win._fbq = win.fbq;
      win.fbq.loaded = true;
      win.fbq.version = '2.0';
      win.fbq.queue = [];

      console.log('Meta Pixel mock initialized in development mode');
    }
  }, [funnelId]);

  return null; // This component doesn't render anything
};

export default MetaPixel;
